module.exports = __webpack_public_path__ + "static/media/52528728_2452984714776705_5966740946115624960_o.9b8446df.jpg";